import React from 'react'
import styled from 'styled-components'
import ImageSlider from '../ImageSlider'
import { ASSETS_URL } from '../../constants/urls'

/* eslint-disable max-len */
const bannerDefault = `${ASSETS_URL}/academy-assets/banners/trial-banner-2.jpg`

const HomeBanner = styled.div`
  position: relative;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    ${props => props.theme.getOption('home.gradientColor')} 35%,
    #ffffff 83%
  );
  display: ${props => (props.carouselEnabled ? 'inline-block' : 'flex')};
  justify-content: center;
  margin-top: ${props => props.theme.getOption('home.bannerTopGap') + 'px'};

  img {
    opacity: 1;
    width: 100%;
    max-width: 1110px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .slick-dots li button:before {
    content: ' ' !important;
  }
  .slick-dots li button {
    width: 11px;
    height: 11px;
    border-radius: 20px;
    background: white;
  }
  .slick-dots li.slick-active button {
    background: var(--clr-accent);
  }

  /** Set the width to 94vw and centered on tiny screens  */
  @media (max-width: 400px) {
    img {
      width: var(--modal-width);
      margin: 10px auto 0;
    }
  }
`

const Slider = ({ theme }) => {
  const homeCarousel = theme.getOption('home.homeCarousel')
  const carouselEnabled = homeCarousel && homeCarousel.length > 1
  return (
    <HomeBanner carouselEnabled={carouselEnabled}>
      <If condition={carouselEnabled}>
        <ImageSlider />
      </If>
      <If condition={theme.getOption('home.bannerImg') && !carouselEnabled}>
        <img src={theme.getOption('home.bannerImg')} alt="" />
      </If>
      <If condition={!theme.getOption('home.bannerImg')}>
        <img src={bannerDefault} alt="" />
      </If>
    </HomeBanner>
  )
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider/index.js